import { useIsFetching, useIsMutating } from '@tanstack/react-query';

/**
 * Thin animated bar pinned to the top of the viewport, visible whenever any
 * React Query request or mutation is in flight. Covers the "cache is stale,
 * refetching in the background" case that isn't obvious to the user.
 */
export default function GlobalLoader() {
  const fetching = useIsFetching();
  const mutating = useIsMutating();
  const active = fetching + mutating;
  if (active === 0) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 3,
        overflow: 'hidden',
        zIndex: 9999,
        pointerEvents: 'none',
      }}
    >
      <div
        style={{
          height: '100%',
          width: '40%',
          background: '#1677ff',
          animation: 'fninja-loader-slide 1s linear infinite',
        }}
      />
      <style>{`
        @keyframes fninja-loader-slide {
          0%   { transform: translateX(-100%); }
          100% { transform: translateX(350%); }
        }
      `}</style>
    </div>
  );
}
